var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSophisticatedMonitoring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.363,
    height: 139.176,
    viewBox: "0 0 161.363 139.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sophisticated_Monitoring",
    "data-name": "Sophisticated Monitoring",
    transform: "translate(0 -35.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2274",
    "data-name": "Group 2274",
    transform: "translate(37.541 75.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2273",
    "data-name": "Group 2273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19720",
    "data-name": "Path 19720",
    d: "M137.316,162.724a18.2,18.2,0,1,0,18.2,18.2A18.22,18.22,0,0,0,137.316,162.724Z",
    transform: "translate(-119.116 -162.724)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2276",
    "data-name": "Group 2276",
    transform: "translate(0 35.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2275",
    "data-name": "Group 2275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19721",
    "data-name": "Path 19721",
    d: "M155.571,35.2H5.788A5.788,5.788,0,0,0,0,40.988v92.781a5.788,5.788,0,0,0,5.788,5.788H8.536L34.4,113.69a1.77,1.77,0,0,0,.123-2.382,27.607,27.607,0,1,1,9.794,7.466,1.768,1.768,0,0,0-1.986.355L21.9,139.557H155.571a5.8,5.8,0,0,0,5.791-5.788V40.991A5.8,5.8,0,0,0,155.571,35.2ZM100.29,117.264a4.726,4.726,0,1,1-9.453,0V99.023a4.726,4.726,0,0,1,9.453,0Zm14.81,0a4.726,4.726,0,1,1-9.453,0V67.513a4.726,4.726,0,0,1,9.453,0Zm15.055,0a4.726,4.726,0,1,1-9.453,0V80.116a4.726,4.726,0,0,1,9.453,0Zm15.065,0a4.726,4.726,0,0,1-9.453,0V92.72a4.726,4.726,0,0,1,9.453,0Z",
    transform: "translate(0 -35.199)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2278",
    "data-name": "Group 2278",
    transform: "translate(40.025 147.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2277",
    "data-name": "Group 2277",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19722",
    "data-name": "Path 19722",
    d: "M205.5,410.32l-.032-.014a95.468,95.468,0,0,0-22.758-6.579v-8.97a1.768,1.768,0,0,0-1.768-1.768H154.37a1.768,1.768,0,0,0-1.768,1.768v8.981a95.448,95.448,0,0,0-22.634,6.545,4.809,4.809,0,0,0-2.672,6.062,4.727,4.727,0,0,0,6.287,2.672A85.93,85.93,0,0,1,167.66,412h.1a86.069,86.069,0,0,1,33.98,6.992l.059.026a4.726,4.726,0,1,0,3.7-8.7Z",
    transform: "translate(-126.999 -392.989)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSophisticatedMonitoring);
export default __webpack_public_path__ + "static/media/Sophisticated Monitoring.84bd9921920d073bb9f59d4965223f3f.svg";
export { ForwardRef as ReactComponent };